import { DataTable, DataTableReader } from '@tableau/api-internal-contract-js';
import { DataTableReaderPagePresModel, DataTableReaderPresModel, ShowDataTableColumnPresModel } from '../../gen-src/preslayer/PresModels';
import { PresLayerOptionalCompatibility } from './PresLayerOptionalCompatibility';
import { buildDataHeaders, buildDataTable } from './ShowDataConverter';

export class DataTableReaderConverter {
  public static convertDataTableReaderPagePresModel(plDataTableReaderPage: DataTableReaderPagePresModel): DataTable {
    const plViewDataTablePage = plDataTableReaderPage.viewDataTablePagePresModel;

    // Explicit map protects us from any future pres model changes.
    const columns: Array<ShowDataTableColumnPresModel> = plViewDataTablePage.viewDataColumnValuesPresModels.map(
      (viewDataColumnValuesPresModel) => {
        return {
          uniqueName: viewDataColumnValuesPresModel.uniqueName,
          fieldCaption: viewDataColumnValuesPresModel.fieldCaption,
          dataType: viewDataColumnValuesPresModel.dataType,
          formatValIdxs: viewDataColumnValuesPresModel.formatValIdxs,
          valueIndices: viewDataColumnValuesPresModel.valueIndices,
        };
      },
    );

    const referencedColumns = plDataTableReaderPage.referencedColumns;
    const dataTable = buildDataTable(
      PresLayerOptionalCompatibility.optionalToRequiredUnsafeCast(plViewDataTablePage.dataDictionary),
      columns,
    );
    const headers = buildDataHeaders(columns, referencedColumns);

    const result: DataTable = {
      dataTable: dataTable,
      headers: headers,
    };

    return result;
  }

  public static convertDataTableReaderPresModel(dataTableReaderPM: DataTableReaderPresModel): DataTableReader {
    return buildDataTableReader(dataTableReaderPM.viewDataTableId, dataTableReaderPM.totalRowCount);
  }
}

export function makeEmptyDataTableReader(): DataTableReader {
  return buildDataTableReader('', 0);
}

function buildDataTableReader(id: string, totalRowCount: number): DataTableReader {
  const result: DataTableReader = {
    id: id,
    totalRowCount: totalRowCount,
  };

  return result;
}
